module.exports = __webpack_public_path__ + "img/label-icon.fd94da5c.png";